import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { api } from "@/lib/api";
import { CheckCircle2, Clock, XCircle } from "lucide-react";

export default function BookingPaypalSuccess() {
  const [params] = useSearchParams();
  const orderId = params.get("token"); // PayPal returns ?token=ORDER_ID&PayerID=...
  const [status, setStatus] = useState("capturing");

  useEffect(() => {
    if (!orderId) { setStatus("error"); return; }
    (async () => {
      try {
        const r = await api.post(`/checkout/paypal/capture/${orderId}`);
        setStatus(r.data.paid ? "paid" : "failed");
      } catch {
        setStatus("failed");
      }
    })();
  }, [orderId]);

  return (
    <div data-testid="paypal-success-page">
      <Navbar/>
      <div className="pt-40 pb-20 px-6 max-w-2xl mx-auto text-center">
        {status === "capturing" && (<>
          <Clock size={56} className="text-[#5DCFE5] mx-auto mb-6 animate-pulse"/>
          <h1 className="font-serif text-4xl mb-2">Confirming PayPal payment...</h1>
          <p className="text-[#6b7c8a]">Almost there — securing your reservation.</p>
        </>)}
        {status === "paid" && (<>
          <CheckCircle2 size={72} className="text-[#5DCFE5] mx-auto mb-6"/>
          <p className="eyebrow mb-3">Confirmed</p>
          <h1 className="font-serif text-5xl mb-4">Your ride is <span className="italic gradient-gold">booked.</span></h1>
          <p className="text-[#b8c5d1] mb-10">A confirmation will be sent to your email shortly. Welcome aboard.</p>
          <Link to="/" data-testid="back-home" className="btn-gold">Back to Home</Link>
        </>)}
        {(status === "failed" || status === "error") && (<>
          <XCircle size={56} className="text-red-400 mx-auto mb-6"/>
          <h1 className="font-serif text-4xl mb-2">Payment not completed</h1>
          <p className="text-[#6b7c8a] mb-8">We couldn't confirm your PayPal payment. Please try again.</p>
          <Link to="/book" className="btn-gold">Try Again</Link>
        </>)}
      </div>
      <Footer/>
    </div>
  );
}
